import React, { useEffect, useState, useCallback } from "react";
import { Field } from "formik";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AlertModal from "web/components/AlertModal";
import Select from "web/components/form-elements/Select";
import NumberInput from "web/components/form-elements/NumberInput";
import RadioButton from "web/components/form-elements/RadioButton";
import UploadSpecification from "web/components/UploadSpecification";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import styled from 'styled-components';

import {
  palletDetails
} from "redux/actions/adminPtPlus";

const SpecificationDetails = (pageProps) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem("token")
  let pageValues = pageProps?.formikProps?.values

  const [materialResponse, setMaterialResponse] = useState("WOOD");
  const woodConditions = ["Recycled", "New", "Combo"]
  let hardOrSoftWoodArray = ['New - Hardwood', 'New - Softwood']
  const plasticConditions = ["Recycled", "New"]
  const [hardOrSoftWoodValue, setHardOrSoftWoodValue] = useState('')
  const [uploadImageStage, setUploadImage] = useState();
  const [isHeatTrearedFlag, setIsHeatTreared] = useState(false);
  const [uploadSpectState, setUploadSpectState] = useState();
  const [filesArr, setFilesArr] = useState();

  const materialArr = [
    {
      id: "0",
      label: "Wood",
      value: "WOOD",
    },
    {
      id: "1",
      label: "Plastic",
      value: "PLASTIC",
    },
    {
      id: "2",
      label: "Other",
      value: "OTHER",
    },
  ];

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const [getMoisture, setMoisture] = useState([]);
  const [getSizeList, setSizeList] = useState([]);
  const [getGradeList, setGradeList] = useState([]);

  let palletList = [
    {
      label: "Block",
      value: "block",
      id: 0,
    },
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    },
    {
      label: "Euro Pallet",
      value: "euroPallet",
      id: 2,
    },
    {
      label: "Crate",
      value: "crate",
      id: 3,
    },
    {
      label: "Tray",
      value: "tray",
      id: 4,
    },
    {
      label: "Other",
      value: "other",
      id: 5,
    }
  ]
  let comboPalletList = [
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    },
    {
      label: "Crate",
      value: "crate",
      id: 2,
    },
    {
      label: "Custom",
      value: "custom",
      id: 3,
    }
  ]
  let corePalletList = [
    {
      label: "Block",
      value: "block",
      id: 0,
    },
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    }
  ]


  const [palletDetailResponse, setPalletDetailResponse] = useState();

  useEffect(() => {
    if (!token) {
      history.push("/")
    } else {
      fetchMyAPI()
    }
  }, []);

  useEffect(() => {
    let pageValues = pageProps?.formikProps?.values
    if (pageValues.flatFeeSpecEdit && pageValues.flatFeeSpecEdit !== '') {
      setMaterialResponse(pageValues.material)
      if (pageValues.moisture && pageValues.moisture !== '') setMoisture([{ label: pageValues.moisture, value: pageValues.moisture }])
      if (pageValues.size && pageValues.size !== '') setSizeList([{ label: pageValues.size, value: pageValues.size }])
      if (pageValues.grade && pageValues.grade !== '') setGradeList([{ label: pageValues.grade, value: pageValues.grade }])
      if (pageValues?.hardOrSoftWood) setHardOrSoftWoodValue(pageValues?.hardOrSoftWood || '')
    }
  }, [])

  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(palletDetails(token));

      if (response?.success) {
        setPalletDetailResponse(response?.data)
      } else {
        if (response?.data?.error?.message === "Invalid Token") {
          history.push("/")
        } else {
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  }, []);
  const materialDiv = () => {
    return (
      <>
        {/* <div className="label-heading"><p>Pallet Details<span className="star">*</span></p></div> */}
        <div className="col-12 text-left mb-40">
          <p className="sec-label" style={{ "font-weight": "bold" }}>Material<span className="star">*</span></p>
          <div className="row">
            {materialArr?.map((value, index) => (
              <div key={index} className="col-4">
                <Field
                  component={RadioButton}
                  name="material"
                  id={value.value}
                  defaultValue={materialResponse}
                  disabled={pageValues.flatFeeSpecEdit === true}
                  onSelect={(e) => {
                    //uploadSpecificationFiles(props)
                    setIsHeatTreared(false)
                    setMaterialResponse(e.target.value)
                    //clearFileds()
                  }}
                  label={value.label}
                  className={(pageValues.flatFeeSpecEdit === true && materialResponse?.toLowerCase() !== value.label?.toLowerCase()) && 'check-disabled'}
                />
              </div>
            ))}
          </div>
        </div></>
    );
  };
  const size = (props, setFieldValue) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="size"
          data={getSizeList}
          placeholder={"Size"}
          disabled={((getSizeList.length === 0) || (pageValues.flatFeeSpecEdit === true)) ? true : false}
          searchable={true}
          maxMenuHeight={60}
          onChangeHandler={(date, val) => {
            // pageProps.setFieldValue("size", data)

            setGradeList([])
            setUploadImage()
            pageProps.setFieldValue("grade", "")
            uploadSpecificationFiles(props)

            if (props.values.condition3) {
              setIsHeatTreared(false)
            } else {
              setIsHeatTreared(true)
            }
            let gradeArr = []
            let filesArr = []
            let conditionTypes = []
            if (props?.values?.condition0) {
              conditionTypes.push("recycled")
            }
            if (props?.values?.condition1) {
              conditionTypes.push("newCondition")
            }
            if (props?.values?.condition2) {
              conditionTypes.push("combo")
            }
            if (props?.values?.condition3) {
              conditionTypes.push("cores")
            }

            const selectedMaterial = props?.values?.material.toLowerCase()
            let palletType = props?.values?.palletType.toLowerCase()
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }

            let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[0]][palletType]
            for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
              if (val === response?.palletSpecificDetails[i]?.size) {
                if (response?.palletSpecificDetails[i]?.grade !== '') {
                  const gradeObject =
                  {
                    label: response?.palletSpecificDetails[i]?.grade,
                    value: response?.palletSpecificDetails[i]?.grade,
                  }

                  gradeArr.push(gradeObject)
                }
                if (props?.values?.moisture === response?.palletSpecificDetails[i]?.moisture) {
                  if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }

                    filesArr.push(fileObject)
                  }
                } else {
                  if (!props?.values?.moisture && response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }
                    filesArr.push(fileObject)
                  }
                }
              }


              if (response?.palletSpecificDetails.length - 1 === i) {
                const gradeNames = gradeArr.map(val => val.value)
                const gradeListFilter = gradeArr.filter(({ value }, index) => !gradeNames.includes(value, index + 1))
                setGradeList(gradeListFilter)
                if (gradeArr.length !== 0) {
                  pageProps.setFieldValue("grade", null)
                }
                // gradeCallBack(gradeListFilter)

                if (gradeListFilter.length === 0) {
                  const filesNames = filesArr.map(val => val.value)
                  const fileListFilter = filesArr.filter(({ value }, index) => !filesNames.includes(value, index + 1))
                  setUploadImage(fileListFilter)
                  setUploadSpectState(fileListFilter)
                }
              }
            }
          }}
        />
      </div>
    );
  };
  const conditions = (arrList) => {
    return (
      <div className="col-12 text-left condition-styles mb-3">
        <p className="mb-3 sec-label" style={{ "font-weight": "bold" }}>Condition<span className="star">*</span></p>
        <div className="row">
          {arrList?.map((value, index) => (
            <div className={'col-md-3'} key={index}>
              <CheckboxInput
                name={"condition" + index}
                label={arrList[index]}
                disabled={pageValues.flatFeeSpecEdit === true}
                // disabled={props?.values?.condition3 ? true : false}
                handleSelect={(val, label) => {
                  setSizeList([])
                  setGradeList([])
                  setMoisture([])
                  setIsHeatTreared(false)
                  pageProps.setFieldValue("palletType", "")
                  pageProps.setFieldValue("moisture", "")
                  pageProps.setFieldValue("size", "")
                  pageProps.setFieldValue("grade", "")

                  pageProps.setFieldValue("condition0", false)
                  pageProps.setFieldValue("condition1", false)
                  pageProps.setFieldValue("condition2", false)
                  pageProps.setFieldValue("condition3", false)
                  pageProps.setFieldValue("hardOrSoftWood", '');
                  if (label === "Recycled" && val)
                    pageProps.setFieldValue("condition0", true)

                  if (label === "New" && val)
                    pageProps.setFieldValue("condition1", true)

                  if (label === "Combo" && val)
                    pageProps.setFieldValue("condition2", true)

                  if (label === "Cores" && val)
                    pageProps.setFieldValue("condition3", true)

                  // if (label === "Cores" && val) {
                  //   setFieldValue("condition0", false)
                  //   setFieldValue("condition1", false)
                  //   setFieldValue("condition2", false)
                  // } else {
                  //   setFieldValue("condition3", false)
                  // }
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const hardOrSoftWoodDiv = (formikProps) => {
    const { setFieldValue } = formikProps
    return (
      <div className="row hardSoftWoodRadioStyle condition-styles mb-1">
        {hardOrSoftWoodArray &&
          hardOrSoftWoodArray.map((value, index) => (
            <div className={'col-md-4'} key={index}>
              <HardSoftWoodWrapper>
                <Field
                  component={RadioButton}
                  name="hardOrSoftWood"
                  id={value}
                  disabled={pageValues.flatFeeSpecEdit === true}
                  defaultValue={hardOrSoftWoodArray[0]}
                  onSelect={(e) => {
                    let tempValue = hardOrSoftWoodValue === e.target?.value ? '' : e.target?.value
                    setFieldValue('hardOrSoftWood', tempValue)
                    setHardOrSoftWoodValue(tempValue)
                  }}
                  label={value}
                  className={(pageValues.flatFeeSpecEdit === true && hardOrSoftWoodValue?.toLowerCase() !== value?.toLowerCase()) && 'check-disabled'}
                />
              </HardSoftWoodWrapper>
            </div>
          ))}
      </div>
    );
  };

  const sizeArrayList = (props, palletType, editFlag, referenceResponse) => {
    if (palletType === "europallet") {
      palletType = "euroPallet"
    }
    let selectedMaterial = props?.values?.material.toLowerCase()
    let conditionTypes = []
    if (editFlag) {
      for (let i = 0; i < referenceResponse?.data?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.data?.palletDetails?.condition[i] === "RECYCLED") {
          conditionTypes.push("recycled")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "NEW") {
          conditionTypes.push("newCondition")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "COMBO") {
          conditionTypes.push("combo")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "CORES") {
          conditionTypes.push("cores")
        }
      }
      selectedMaterial = referenceResponse?.data?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    let sizeArr = []
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[j]][palletType]
      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.size !== '') {
            const sizeObject =
            {
              label: response?.palletSpecificDetails[i]?.size,
              value: response?.palletSpecificDetails[i]?.size,
              quantity: response?.palletSpecificDetails[i]?.quantity,
            }

            sizeArr.push(sizeObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {

            if (conditionTypes.length - 1 === j) {
              if (sizeArr.length === 0)
                gradeArrayList(props, palletType, editFlag, referenceResponse)
            }

            const sizeNames = sizeArr.map(val => val.value)
            const sizeListFilter = sizeArr.filter(({ value }, index) => !sizeNames.includes(value, index + 1))
            setSizeList(sizeListFilter)
          }
        }
      }
    }
  }
  let fileArr = [];
  const uploadSpecificationFiles = (props) => {
    let flag = false
    if (props?.values?.grade === "Custom" || props?.values?.size === "Custom") {
      flag = true
    }
    return (
      <div className="stepUpload request-order-upload-section">
        <UploadSpecification
          acceptFiles="image/png,image/jpeg,image/gif"
          name="uploadSpecification"
          btnName={"Upload Specification"}
          mandatory={flag ? "Star" : ""}
          props={props}
          fileArr={fileArr}
          callBackFun={(imageArr) => {
            //callBack(imageArr);
            setFilesArr(imageArr);
          }}
        />
      </div>)
  }
  const gradeArrayList = (props, palletType, editFlag, referenceResponse) => {
    let selectedMaterial = props?.values?.material.toLowerCase()
    let conditionTypes = []
    if (editFlag) {
      for (let i = 0; i < referenceResponse?.data?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.data?.palletDetails?.condition[i] === "RECYCLED") {
          conditionTypes.push("recycled")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "NEW") {
          conditionTypes.push("newCondition")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "COMBO") {
          conditionTypes.push("combo")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "CORES") {
          conditionTypes.push("cores")
        }
      }
      selectedMaterial = referenceResponse?.data?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    let gradeArr = []
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[j]][palletType]
      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.grade !== '') {
            const gradeObject =
            {
              label: response?.palletSpecificDetails[i]?.grade,
              value: response?.palletSpecificDetails[i]?.grade,
            }

            gradeArr.push(gradeObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            const gradeNames = gradeArr.map(val => val.value)
            const gradeListFilter = gradeArr.filter(({ value }, index) => !gradeNames.includes(value, index + 1))
            setGradeList(gradeListFilter)
            if (gradeArr.length !== 0) {
              pageProps.setFieldValue("grade", null)
            }
          }
        }
      } else {
        setMoisture([])
        setSizeList([])
      }
    }
  }
  const palletType = (props, setFieldValue) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="palletType"
          data={props?.values?.condition2 ? comboPalletList : props?.values?.condition3 ? corePalletList : palletList}
          placeholder={"Pallet Type"}
          disabled={((!props?.values?.condition0 && !props?.values?.condition1 && !props?.values?.condition2 && !props?.values?.condition3) || (pageValues.flatFeeSpecEdit === true)) ? true : false}
          searchable={true}
          maxMenuHeight={120}
          onChangeHandler={(data, val) => {
            let palletType = val
            //clearFileds()
            setGradeList([])
            pageProps.setFieldValue("width", "")
            pageProps.setFieldValue("height", "")
            pageProps.setFieldValue("length", "")
            pageProps.setFieldValue("palletType", "")
            pageProps.setFieldValue("moisture", "")
            pageProps.setFieldValue("size", "")
            pageProps.setFieldValue("grade", "")
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }
            palletTypeData(pageProps.formikProps, palletType)
          }}
        />
      </div>
    );
  };

  const palletTypeData = (props, palletType, editFlag, referenceResponse) => {
    let moistureArr = []
    let conditionTypes = []
    let selectedMaterial = props?.values?.material?.toLowerCase()
    if (editFlag) {
      for (let i = 0; i < referenceResponse?.data?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.data?.palletDetails?.condition[i] === "RECYCLED") {
          conditionTypes.push("recycled")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "NEW") {
          conditionTypes.push("newCondition")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "COMBO") {
          conditionTypes.push("combo")
        } if (referenceResponse?.data?.palletDetails?.condition[i] === "CORES") {
          conditionTypes.push("cores")
        }
      }
      selectedMaterial = referenceResponse?.data?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    if (palletType === "custom") {
      const sizeObject = [
        {
          label: "Custom",
          value: "Custom",
        }
      ]
      setSizeList(sizeObject)
    }


    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[j]][palletType]

      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.moisture !== '') {
            const moistureObject =
            {
              label: response?.palletSpecificDetails[i]?.moisture,
              value: response?.palletSpecificDetails[i]?.moisture,
            }
            moistureArr.push(moistureObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            const moistureNames = moistureArr.map(val => val.value)
            const moistureArrListFilter = moistureArr.filter(({ value }, index) => !moistureNames.includes(value, index + 1))
            setMoisture(moistureArrListFilter)

            if (conditionTypes.length - 1 === j) {
              if (moistureArr.length === 0) {
                sizeArrayList(props, palletType)
              } else {
                // sizeArrayList(props, palletType,editFlag,referenceResponse)
              }

            }
          }
        }
      } else {
        setMoisture([])
        setSizeList([])
      }
    }
  }

  const moisture = (props) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="moisture"
          data={getMoisture}
          placeholder={"Moisture"}
          maxMenuHeight={120}
          disabled={((getMoisture.length === 0) || (pageValues.flatFeeSpecEdit === true)) ? true : false}
          searchable={true}
          onChangeHandler={() => {
            let palletType = props?.values?.palletType
            sizeArrayList(props, palletType)
          }}
        />
      </div>
    );
  };

  const grade = (props) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="grade"
          data={getGradeList}
          placeholder={"Grade"}
          maxMenuHeight={60}
          disabled={((getGradeList.length === 0 || props?.values?.size === "Custom") || (pageValues.flatFeeSpecEdit === true)) ? true : false}
          searchable={true}
          onChangeHandler={(data, val) => {
            if (props.values.condition3) {
              setIsHeatTreared(false)
            } else {
              setIsHeatTreared(true)
            }
            uploadSpecificationFiles(props)

            let filesArr = []
            let conditionTypes = []
            if (props?.values?.condition0) {
              conditionTypes.push("recycled")
            }
            if (props?.values?.condition1) {
              conditionTypes.push("newCondition")
            }
            if (props?.values?.condition2) {
              conditionTypes.push("combo")
            }
            if (props?.values?.condition3) {
              conditionTypes.push("cores")
            }

            const selectedMaterial = props?.values?.material.toLowerCase()
            let palletType = props?.values?.palletType.toLowerCase()
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }

            let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[0]][palletType]
            for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
              if (response?.palletSpecificDetails[i].size === props?.values?.size) {
                if (val === response?.palletSpecificDetails[i]?.grade) {
                  if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }

                    filesArr.push(fileObject)
                  }
                }
              }

              if (response?.palletSpecificDetails.length - 1 === i) {
                const filesNames = filesArr.map(val => val.value)
                const fileListFilter = filesArr.filter(({ value }, index) => !filesNames.includes(value, index + 1))
                setUploadImage(fileListFilter)
                setUploadSpectState(fileListFilter)
              }

            }
          }}
        />
      </div>
    );
  };
  const customFields = () => {
    return (
      <div className="text-left  mb-40">
        <div className="row">
          <div className="col-md-4 col-sm-6">
            <div className="app-input-text">
              <NumberInput
                name="length"
                placeholder="Length*"
                maxLength={5}
                showErrorMessages={true}
                disabled={pageValues.flatFeeSpecEdit === true}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="app-input-text">
              <NumberInput
                name="width"
                placeholder="Width*"
                maxLength={5}
                showErrorMessages={true}
                disabled={pageValues.flatFeeSpecEdit === true}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div>
              <NumberInput
                name="height"
                placeholder="Height*"
                maxLength={5}
                disabled={pageValues.flatFeeSpecEdit === true}
                onChangeHandler={() => { }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isHeatTreated = () => {
    return (
      <div className="col-6 text-left" style={{ "margin-top": "-20px" }}>
        <div className="row">
          <CheckboxInput
            name={"isHeatTreared"}
            label="Heat Treated"
            disabled={pageValues.flatFeeSpecEdit === true}
            handleSelect={() => {
            }}
          />
        </div>
      </div>
    )
  }

  return <>
    <div>
      <div className="row">
        {materialDiv()}
      </div>
      <div className="row">
        {materialResponse === "WOOD" && conditions(woodConditions)}
        {materialResponse === "PLASTIC" && conditions(plasticConditions)}
        {pageProps.formikProps?.values?.condition1 && materialResponse === "WOOD" && hardOrSoftWoodDiv(pageProps.formikProps)}
      </div>

      <div>
        <div className="row">
          <div className="col-md-6">
            {materialResponse === "WOOD" && palletType(pageProps.formikProps)}
          </div>
          <div className="col-md-6">
            {materialResponse === "WOOD" && moisture(pageProps.formikProps)}
          </div>
        </div>
      </div>

      <div>
        <div className="row">
          <div className="col-md-6">
            {materialResponse === "WOOD" && size(pageProps.formikProps)}
          </div>
          <div className="col-md-6">
            {materialResponse === "WOOD" && grade(pageProps.formikProps)}
          </div>
        </div>
      </div>
      {(materialResponse !== "WOOD" || pageProps.formikProps?.values?.size === "Custom") && customFields(pageProps.formikProps)}
      <div style={{ display: 'flex' }}>
        {isHeatTrearedFlag && isHeatTreated(pageProps.props)}
        {!isHeatTrearedFlag && pageValues.isHeatTreared && pageValues.flatFeeSpecEdit === true && isHeatTreated(pageProps.props)}
        {(!pageValues.flatFeeSpecEdit || (pageValues.flatFeeSpecEdit && pageProps.formikProps?.values?.isLtl)) &&
          <div className="col-6 text-left" style={{ "margin-top": "-20px", paddingLeft: 0 }}>
            <CheckboxInput
              name='isLtl'
              label="LTL"
              disabled={pageValues.flatFeeSpecEdit === true}
              handleSelect={() => {
              }}
            />
          </div>
        }
      </div>
    </div>

    <AlertModal
      isOpen={modal}
      toggle={toggleModal}
      title="Alert"
      content={modalContent}
      link={modalLink}
      className="alert-msg-container"
      InnerClassName="alert-msg"
    />

  </>
}

export default SpecificationDetails;

const HardSoftWoodWrapper = styled.div`
  margin-left: 15px;
  width: 275px;
  .radio-checkmark{
      width: 18px;
      height: 18px;
      border-radius: 0px;      
      position: absolute !important;
      top: 0px !important;
    }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 0px;
  }
  .radio-container {
    span {
      white-space : nowrap;
      position: relative;
      top: -6px;
    }
  }
`